module.exports = __webpack_public_path__ + "media/images/pages/about_us/partners/logo_bpi-7c11e8570bd3c9c45818bfa2e5485a9b.png";